module.exports = __webpack_public_path__ + "static/media/tg.254fd423.svg";